export const communicateLocales = {
  /* COMMUNICATE */
  'category.communicate.description': 'Contacter votre proche',
  'category.communicate.label': 'Contacter',

  'category.communicate.subcategory.visio': 'Visio',
  'category.communicate.subcategory.postcard': 'Carte postale',

  /* Postcard */
  'postcard.button.flipCard': 'Retourner la carte',
  'postcard.button.loadPhoto': 'Charger une photo',
  'postcard.description': 'Envoyer une carte postale',
  'postcard.crop': 'Recadrer',
  'postcard.sent': 'Carte postale envoyée',
  'postcard.saveError': 'Erreur de sauvegarde de la carte postale',
  'postcard.tryLater':
    "Echec d'envoi de la carte postale, veuillez réessayer ultérieurement",

  /* Video call */
  'videoCall.home.title': 'Appels visio',
  'videoCall.home.explainations': "En démarrant l'appel, la tablette de {tabletOwner} va sonner et l'inviter à rejoindre l'appel.\nUn email sera envoyé aux autres participants pour les inviter à vous rejoindre.",
  'videoCall.home.videoCallList.title': 'Appels vidéo en cours',
  'videoCall.home.videoCallList.noVideoCall': 'Aucun appel vidéo en cours',
  'videoCall.create.title': 'Démarrer un appel vidéo',
  'videoCall.create.participantsList.title': 'Participants',
  'videoCall.create.participantsAdd.title': 'Ajouter un participant',
  'videoCall.create.participantsAdd.addButton': 'Ajouter',
  'videoCall.create.participantsAdd.sendInviteButton': "Envoyer l'invitation",
  'videoCall.home.videoCallList.createdToast.title': 'Invitation envoyée',
  'videoCall.home.videoCallList.createdToast.body': "L'invitation pour rejoindre l'appel a été envoyée",
  'videoCall.home.videoCallList.videoCallCard.title': 'Appel vidéo de {videoCallCreator}',
  'videoCall.home.videoCallList.videoCallCard.invited': '{participantsNumber} participants',
  'videoCall.home.videoCallList.videoCallCard.dateCreation': 'Créé le {date}',
  'videoCall.home.videoCallList.videoCallCard.dateCreationWithHours': ' - il y a {time} {unit}',
  'videoCall.home.videoCallList.videoCallCard.joinCall': "Rejoindre l'appel vidéo",
  'videoCall.call.title': "Appel avec {tabletOwner}",
  'videoCall.call.firstName': "Prénom",
  'videoCall.call.join': "Rejoindre maintenant",
  'videoCall.call.toolbar.leaveCall': "Quitter l'appel",
  'videoCall.call.toolbar.microphoneMuted': "Micro désactivé",
  'videoCall.call.toolbar.microphoneActive': "Micro activé",
  'videoCall.call.toolbar.cameraMuted': "Caméra désactivé",
  'videoCall.call.toolbar.cameraActive': "Caméra activé",
  'videoCall.call.ended.title': "L'appel vidéo est terminé",
  'videoCall.call.ended.body': "Saviez-vous qu'avec le site Famille ardoiz, vous pouvez facilement partager des photos, organiser un appel vidéo, créer un rendez-vous dans l'agenda et bien d'autres choses encore !",
  'videoCall.call.ended.goToSiteFamille': 'Rejoindre le site famille',
  'videoCall.call.notfound.title': 'Appels vidéo',
  'videoCall.call.notfound.subtitle': "L'appel vidéo a expiré.",
  'videoCall.call.notfound.description': "L'appel vidéo a été créé il y a plus de 48h. Passé ce délai, l'invitation à rejoindre l'appel vidéo expire.",
  'videoCall.call.notfound.backtohome': "Découvrir la tablette ardoiz",

  'videoCall.incomingcall': 'Appel vidéo entrant',
  'videoCall.button.call': 'Appeler',
  'videoCall.calling': 'Appel visio en cours',
  'videoCall.description': 'Appeler en visio',
  'videoCall.activated.male': 'activé',
  'videoCall.activated.female': 'activée',
  'videoCall.deactivated.male': 'désactivé',
  'videoCall.deactivated.female': 'désactivée',
  'videoCall.mic': 'Micro',
  'videoCall.camera': 'Caméra',
  'videoCall.fullscreen.activated': 'Mode<br></br>plein écran',
  'videoCall.fullscreen.deactivated': 'Mode<br></br>réduit',

  'videoCall.notification.new': 'Nouvelle notification !',

  'videoCall.error.androidVersion':
    'Nous sommes désolés, la tablette Ardoiz de votre proche est trop ancienne pour bénéficier de la nouvelle fonctionnalité « appel vidéo »',

  'videoCall.error.ardoizCoreVersion':
    "L’ardoiz Visio est actuellement en maintenance, veuillez nous excuser pour la gêne occasionnée. La nouvelle version sera disponible à partir de la rentrée 2024 sur notre site famille Ardoiz. Votre proche utilisateur de la tablette devra faire installer la mise à jour ardoiz 3.1 de son coté. Merci pour votre patience.",

  'videoCall.error.initialization':
    "Erreur lors de l'initialisation de l'appel visio",

  'videoCall.error.sendNotification': "Erreur lors de la tentative d'appel",

  'videoCall.error.waitNotificationAcknowledgment':
    "Erreur lors de l'attente de réception d'appel",

  'videoCall.error.NotificationAcknowledgeBusy':
    'est indisponible / occupée',

  'videoCall.error.NotificationAcknowledgeTimeout1.tablet': 'La tablette de',

  'videoCall.error.NotificationAcknowledgeTimeout2.tablet':
    "n'est pas connectée",

  'videoCall.error.NotificationAcknowledgeTimeout': "n'est pas connecté(e)",

  'videoCall.error.notificationSent':
    'Votre contact va être notifié par email de votre appel et pourra vous rappeler très prochainement',

  'videoCall.error.waitAccept': "Problème pendant l'attente d'acceptation",

  'videoCall.message.Ended1': 'Appel visio avec',

  'videoCall.message.Ended2': 'terminé',

  'videoCall.message.Interrupted1': 'Appel vers',

  'videoCall.message.Interrupted2': 'interrompu',

  'videoCall.error.CallAnswerTimeout': 'Pas de réponse de la part de',

  'videoCall.error.CallStartTimeout':
    "n'a pas pu se connecter au salon visio dans le temps imparti, veuillez réessayer",

  'videoCall.error.CallRefused': 'a décliné votre appel',

  'videoCall.error.getVideoCall':
    "Problème de récupération du salon d'appel visio",

  'videoCall.error.accept': "Erreur lors de l'acceptation de l'appel",

  'videoCall.error.refuse': "Erreur lors du refus de l'appel",
};
